import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { LOGIN_BUTTON_CLICKED, SIGN_UP_BUTTON_CLICKED } from 'apps/promo/constants/amplitude/AmplitudeEvents';
import { QR_POPUP } from 'apps/promo/constants/ComponentNames';
import { useUrlWithTrackingParams } from 'apps/promo/hooks/useUrlWithTrackingParams';

import HeaderFixedButton from './HeaderFixedButton';
import styles from './HeaderFixedButtons.module.css';
import GetStartedButton from '../common/get-started-button/GetStartedButton';
import QRPopup from '../common/Popups/QRPopup';
import RequestFormPopup from '../common/Popups/RequestFormPopup/RequestFormPopup';
import PromoPopup from '../popup/PromoPopup';

const HeaderFixedButtons = (props) => {
    const linksStore = props.data[0]?.nav_links || {};
    const [visibleLinks, setVisibleLinks] = useState([]);
    const [pageData, setPageData] = useState({});

    const popupRef = useRef(null);
    const addTrackingParamsToUrl = useUrlWithTrackingParams();

    const zendeskSubmitRequestLink = `/zendesk/request?lang=${props.lang}&country=${props.country}`;

    const selectPopupSnippet = (popupName) => {
        if (popupName === QR_POPUP) {
            popupRef.current?.open(<QRPopup hasAppsBtns={true} popupRef={popupRef} isReferral={props.isReferral} />);
        } else {
            popupRef.current?.open(<RequestFormPopup sendFrom={props.sendFrom} popupRef={popupRef} />);
        }
    };
    const sendAmplitudeEvent = (url) => {
        const eventName = url === '/registration' ? SIGN_UP_BUTTON_CLICKED : LOGIN_BUTTON_CLICKED;
        amplitude.getInstance().logEvent(eventName);
    };

    const applyPageData = (isLanding, pageName, isAuth) => {
        const result = { name: '', auth: isAuth };

        if (isLanding) {
            result.name = 'landing';
        } else if (pageName) {
            result.name = pageName;
        } else {
            result.name = 'other';
        }

        setPageData(result);
    };

    const filterLinks = (links, pageData) => {
        switch (pageData.name) {
            case 'landing':
                setVisibleLinks(linksStore.filter((item) => item.additional_info == pageData.name && item.authorised_user === pageData.auth));
                break;
            case 'other':
                if (pageData.auth) {
                    setVisibleLinks(linksStore.filter((item) => item.authorised_user === pageData.auth));
                } else {
                    setVisibleLinks(linksStore.filter((item) => item.additional_info == pageData.name));
                }
                break;

            default:
                setVisibleLinks(linksStore.filter((item) => item.additional_info == pageData.name));
        }
    };

    useEffect(() => {
        const isAuth = sessionStorage.getItem('isLoggedIn') === 'true';

        if (Array.isArray(linksStore) && linksStore.length > 0) {
            applyPageData(props.isLanding, props.pageName, isAuth);
            filterLinks(linksStore, pageData);
        }
    }, [pageData.name]);

    const linksCodeSnippet =
        Array.isArray(visibleLinks) &&
        visibleLinks
            .filter((item) => item !== null)
            .map((link) => {
                return (
                    <li key={link.id}>
                        {pageData && !link.modal_window && link.title && link.url && !link.isExternalButton && (
                            <HeaderFixedButton
                                onClick={() => {
                                    sendAmplitudeEvent(link.url);
                                }}
                                variant={link.color}
                                caption={link.title}
                                href={pageData.name === 'zendesk' ? zendeskSubmitRequestLink : addTrackingParamsToUrl(link.url)}
                                targetBlank={pageData.name === 'zendesk'}
                                id={link.title}
                                fixedButton={props.fixedHeader}
                            />
                        )}
                        {pageData && link.modal_window && link.title && !link.isExternalButton && (
                            <HeaderFixedButton
                                caption={link.title}
                                variant={link.color}
                                onClick={() => selectPopupSnippet(link.modal_window)}
                                id={link.title}
                                tabIndex={'0'}
                                fixedButton={props.fixedHeader}
                            />
                        )}
                        {link.isExternalButton && link.title && (
                            <GetStartedButton
                                buttonText={link.title}
                                isNavButton
                                promoDarkPage
                                fixedHeader={props.fixedHeader}
                                isMobileMenu={props.isMobileMenu}
                                fixedButton={props.fixedHeader}
                            />
                        )}
                    </li>
                );
            });

    return (
        <>
            {pageData && visibleLinks && linksCodeSnippet && (
                //visibleLinks.length === 1
                <ul className={`${styles.buttonsMenu} ${props.hasChatButton ? styles.buttonsMenuAlignedLeft : null}`}>{visibleLinks && linksCodeSnippet}</ul>
            )}
            <PromoPopup ref={popupRef} />
        </>
    );
};

HeaderFixedButtons.propTypes = {
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.oneOf([null])]),
    isLanding: PropTypes.bool,
    isReferral: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        lang: state.extra.noAuthFooter?.language?.lang,
        country: state.extra.noAuthFooter?.language?.country,
    };
};

export default connect(mapStateToProps, null)(HeaderFixedButtons);
